import ChannelOrderManage from '@/pages/handle/channelOrderManage'

export default [
  {
    path: '/channelOrderManage',
    name: 'ChannelOrderManage',
    component: ChannelOrderManage,
    meta: { name: '订单处理' }
  }
]



// WEBPACK FOOTER //
// ./src/router/handle/channelOrderManage.js